import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogPipesModule } from '../../../pipes/change-log-pipes.module';
import { ChangeLogGuestEventsComponent } from './change-log-guest-events.component';

@NgModule({
  declarations: [ChangeLogGuestEventsComponent],
  imports: [CommonModule, SharedModule, ChangeLogPipesModule],
  exports: [ChangeLogGuestEventsComponent],
})
export class ChangeLogGuestEventsModule {}
